import { format, parseISO } from "date-fns";
import type {
  MonitoringPlanActor,
  MonitoringPlanAppointmentRef,
  MonitoringPlanEntry,
} from "@/types/monitoring";

export const formatRole = (role?: string | null) =>
  role ? role.replace(/_/g, " ") : "";

export const formatActor = (actor: MonitoringPlanActor | null) =>
  actor
    ? `${actor.name}${actor.role ? ` (${formatRole(actor.role)})` : ""}`
    : "Unknown";

export const formatPlanDate = (iso: string) =>
  format(parseISO(iso), "dd MMM yyyy");

export const formatAppointmentRef = (
  appt: MonitoringPlanAppointmentRef | null
) => appt?.zarity_appointment_id || "Between visits";

export const describeEntry = (entry: MonitoringPlanEntry | null) => {
  if (!entry) return "—";
  const parts = [entry.frequency?.name ?? "No frequency"];
  if (entry.advice) parts.push(`“${entry.advice}”`);
  return parts.join(", ");
};
